import { render, staticRenderFns } from "./MedicalRecordExclude.vue?vue&type=template&id=4be82e22&"
import script from "./MedicalRecordExclude.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordExclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports